import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { Testentity } from './testentity.model';
import { TestentityPopupService } from './testentity-popup.service';
import { TestentityService } from './testentity.service';
import { Contact, ContactService } from '../contact';

@Component({
    selector: 'jhi-testentity-dialog',
    templateUrl: './testentity-dialog.component.html'
})
export class TestentityDialogComponent implements OnInit {

    testentity: Testentity;
    authorities: any[];
    isSaving: boolean;

    contacts: Contact[];
        constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        private alertService: AlertService,
        private testentityService: TestentityService,
        private contactService: ContactService,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['testentity']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.contactService.query().subscribe(
            (res: Response) => { this.contacts = res.json(); }, (res: Response) => this.onError(res.json()));
    }
    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.isSaving = true;
        if (this.testentity.id !== undefined) {
            this.testentityService.update(this.testentity)
                .subscribe((res: Testentity) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        } else {
            this.testentityService.create(this.testentity)
                .subscribe((res: Testentity) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        }
    }

    private onSaveSuccess(result: Testentity) {
        this.eventManager.broadcast({ name: 'testentityListModification', content: 'OK'});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        try {
            error.json();
        } catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }

    trackContactById(index: number, item: Contact) {
        return item.id;
    }
}

@Component({
    selector: 'jhi-testentity-popup',
    template: ''
})
export class TestentityPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private testentityPopupService: TestentityPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            if ( params['id'] ) {
                this.modalRef = this.testentityPopupService
                    .open(TestentityDialogComponent, params['id']);
            } else {
                this.modalRef = this.testentityPopupService
                    .open(TestentityDialogComponent);
            }
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/testentity/testentity-dialog.component.ts